import request from '@/utils/request'

/**
 * 获取用户VIP信息列表
 * @param {Object} params 查询参数
 * @param {String} params.vipTel 会员手机号 
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 */
export function getVipList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryAdminVipUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}